import CryptoJS from "crypto-js";

const secretKey = "e9w9r3q1w7d4f7t1g6c0s7v6c1x7z3b8m1y9e6a4q7e5t0r6n0l1p3u8a4z0h4!@#";

export const hasToken = () => localStorage.getItem("token") !== null;

// Returns the decrypted token, or "" when the ciphertext is invalid.
export const decryptToken = (ciphertext) => {
  try {
    const decodedCiphertext = decodeURIComponent(ciphertext);
    const bytes = CryptoJS.AES.decrypt(decodedCiphertext, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};

// Handles the ?token= and ?tour= params the mobile app and emails link with.
// An invalid token is ignored rather than stored, so it can't count as a login.
export const applyAuthParams = (search) => {
  const params = new URLSearchParams(search);
  const tokenFromParams = params.get("token");
  const tour = params.get("tour");

  if (tokenFromParams) {
    const decryptedToken = decryptToken(tokenFromParams);
    if (decryptedToken) {
      localStorage.setItem("token", decryptedToken);
    }
  }
  if (tour) {
    localStorage.setItem("is_tour_complete", tour);
  }
  return params;
};
